import { render } from "./ThirdStepServicesForm.vue?vue&type=template&id=4bfb611d"
import script from "./ThirdStepServicesForm.vue?vue&type=script&lang=js"
export * from "./ThirdStepServicesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__